/* Laat Hy Val Waar Hy Will — theme.js (no dependencies) */
(() => {
  'use strict';
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const root = (T.routes.root || '/').replace(/\/?$/, '/');

  /* ───────── Drawers ───────── */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const panel = el.querySelector('[role="dialog"], nav') || el;
    setTimeout(() => (el.querySelector('[data-drawer-close]:not(.drawer__overlay), [data-menu-close]:not(.drawer__overlay)') || panel).focus(), 50);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  const cartDrawer = () => $('[data-cart-drawer]');
  const menuDrawer = () => $('[data-menu-drawer]');

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openDrawer(menuDrawer()); e.target.closest('[data-menu-open]').setAttribute('aria-expanded', 'true'); }
    if (e.target.closest('[data-menu-close]')) { closeDrawer(menuDrawer()); const b = $('[data-menu-open]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    if (e.target.closest('[data-cart-open]') && T.cartType === 'drawer' && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer(cartDrawer()); }
    if (e.target.closest('[data-drawer-close]')) closeDrawer(cartDrawer());
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeDrawer(cartDrawer()); closeDrawer(menuDrawer()); }
    if (e.key === 'Tab') {
      const open = $('.drawer.is-open, .menu-drawer.is-open');
      if (!open) return;
      const f = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', open).filter((n) => n.offsetParent !== null);
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ───────── Cart rendering (Section Rendering API) ───────── */
  const SECTIONS = ['cart-drawer'];
  function renderSections(sections) {
    if (!sections) return;
    if (sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const fresh = html.querySelector('.drawer__panel');
      const current = $('[data-cart-drawer] .drawer__panel');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    }
  }
  function updateCount(count) {
    $$('[data-cart-count]').forEach((n) => { n.textContent = count; n.hidden = count === 0; });
    $$('[data-cart-open]').forEach((n) => n.setAttribute('aria-label', n.getAttribute('aria-label').replace(/\d+/, count)));
  }
  async function refreshCount() {
    try { const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); updateCount(c.item_count); return c; } catch (e) { return null; }
  }

  /* Add to cart */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.product-form');
    if (!form) return;
    if (T.cartType !== 'drawer') return; // native POST → cart page
    e.preventDefault();
    const btn = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const err = form.querySelector('[data-form-error]');
    if (err) err.hidden = true;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    const prev = label.textContent; label.textContent = T.strings.adding;
    try {
      const fd = new FormData(form);
      fd.append('sections', SECTIONS.join(','));
      fd.append('sections_url', window.location.pathname);
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      renderSections(data.sections);
      await refreshCount();
      openDrawer(cartDrawer());
    } catch (ex) {
      if (err) { err.textContent = ex.message || T.strings.cartError; err.hidden = false; }
    } finally {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); label.textContent = prev;
    }
  });

  /* Line item quantity changes (drawer + cart page) */
  async function changeLine(line, quantity, scope) {
    const list = scope.querySelector('.cart-lines');
    if (list) list.classList.add('is-updating');
    try {
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: SECTIONS, sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.cartError);
      if (scope.closest('[data-cart-page]')) { window.location.reload(); return; }
      renderSections(data.sections);
      updateCount(data.item_count);
    } catch (ex) {
      if (list) list.classList.remove('is-updating');
      alert(ex.message || T.strings.cartError);
    }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]');
    if (!b) return;
    const li = b.closest('[data-line]');
    const scope = b.closest('[data-cart-drawer], [data-cart-page]');
    changeLine(parseInt(li.dataset.line, 10), Math.max(0, parseInt(b.dataset.lineChange, 10)), scope);
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) {
      const li = input.closest('[data-line]');
      changeLine(parseInt(li.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0), input.closest('[data-cart-drawer], [data-cart-page]'));
    }
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  /* Product quantity buttons */
  document.addEventListener('click', (e) => {
    const minus = e.target.closest('[data-qty-minus]');
    const plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    const input = (minus || plus).closest('[data-qty]').querySelector('input');
    const v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
  });

  /* ───────── Variants ───────── */
  $$('form.product-form').forEach((form) => {
    const json = form.querySelector('[data-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const selects = $$('[data-option-index]', form);
    const money = (cents) => 'R ' + (cents / 100).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    selects.forEach((s) => s.addEventListener('change', () => {
      const chosen = selects.map((x) => x.value);
      const v = variants.find((vv) => vv.options.every((o, i) => o === chosen[i]));
      const btn = form.querySelector('[data-add-button]');
      const label = form.querySelector('[data-add-label]');
      if (!v) { btn.disabled = true; label.textContent = T.strings.unavailable; return; }
      form.querySelector('[data-variant-id]').value = v.id;
      btn.disabled = !v.available;
      label.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      const section = form.closest('[data-product-section]');
      if (section) {
        const p = section.querySelector('[data-product-price] .price__current');
        if (p) p.textContent = money(v.price);
        const sp = section.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
        if (v.featured_media) { const slide = section.querySelector('[data-media-id="' + v.featured_media.id + '"]'); if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); }
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
    }));
  });

  /* ───────── Gallery ───────── */
  $$('[data-gallery]').forEach((g) => {
    const track = g.querySelector('[data-gallery-track]');
    const thumbs = $$('[data-gallery-thumb]', g);
    if (!track || !thumbs.length) return;
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = parseInt(t.dataset.galleryThumb, 10);
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      });
    }, { passive: true });
  });

  /* ───────── Sticky add-to-cart ───────── */
  const sticky = $('[data-sticky-atc]');
  const mainBuy = $('[data-main-buy]');
  const footer = $('.footer');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    let buyVisible = true, footerVisible = false;
    const btn = sticky.querySelector('[data-sticky-btn]');
    const sync = () => {
      const show = !buyVisible && !footerVisible && !document.body.classList.contains('is-locked');
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (btn) btn.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(([en]) => { buyVisible = en.isIntersecting || en.boundingClientRect.top > 0; sync(); }).observe(mainBuy);
    if (footer) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; sync(); }).observe(footer);
  }

  /* ───────── Display readout (only when verified values are set) ───────── */
  $$('[data-readout]').forEach((r) => {
    const values = (r.dataset.values || '').split(',').map((s) => s.trim()).filter(Boolean);
    const out = r.querySelector('[data-readout-value]');
    if (values.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    setInterval(() => {
      r.classList.add('is-swapping');
      setTimeout(() => { i = (i + 1) % values.length; out.textContent = values[i]; r.classList.remove('is-swapping'); }, 250);
    }, 2200);
  });

  /* ───────── Reveal on scroll ───────── */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }
  if (window.Shopify && window.Shopify.designMode) reveals.forEach((el) => el.classList.add('is-visible'));

  /* ───────── Delivery estimator (Shopify shipping rates) ───────── */
  $$('[data-shipping-estimator]').forEach((box) => {
    const btn = box.querySelector('[data-est-submit]');
    const out = box.querySelector('[data-est-results]');
    btn.addEventListener('click', async () => {
      const zip = box.querySelector('[data-est-zip]').value.trim();
      const province = box.querySelector('[data-est-province]').value;
      const country = box.querySelector('[data-est-country]').value;
      out.textContent = T.strings.shippingLoading;
      btn.disabled = true;
      const q = 'shipping_address[zip]=' + encodeURIComponent(zip) + '&shipping_address[country]=' + encodeURIComponent(country) + '&shipping_address[province]=' + encodeURIComponent(province);
      try {
        await fetch(root + 'cart/prepare_shipping_rates.json?' + q, { method: 'POST' });
        let data = null;
        for (let n = 0; n < 8; n++) {
          const r = await fetch(root + 'cart/async_shipping_rates.json?' + q);
          if (r.status === 200) { data = await r.json(); if (data && data.shipping_rates) break; }
          await new Promise((res) => setTimeout(res, 600));
        }
        if (!data || !data.shipping_rates) throw new Error();
        if (!data.shipping_rates.length) { out.textContent = T.strings.shippingNone; return; }
        const ul = document.createElement('ul');
        data.shipping_rates.forEach((rate) => {
          const li = document.createElement('li');
          const price = parseFloat(rate.price) === 0 ? 'R 0.00' : 'R ' + parseFloat(rate.price).toLocaleString('en-ZA', { minimumFractionDigits: 2 });
          li.textContent = rate.name + ': ' + price + (rate.delivery_range && rate.delivery_range.length ? ' (' + rate.delivery_range.join(' – ') + ')' : '');
          ul.appendChild(li);
        });
        out.innerHTML = ''; out.appendChild(ul);
      } catch (ex) {
        out.textContent = T.strings.shippingError;
      } finally { btn.disabled = false; }
    });
  });

  /* Keep the header count fresh after back/forward cache restores */
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });
})();
